module.exports = __webpack_public_path__ + "static/media/18ECA47.465d53f2.jpg";